function customFormatMoney(cents) {
  return new Intl.NumberFormat(
    `${window.Shopify.locale}-${window.Shopify.country}`,
    {
      style: "currency",
      currency: window.Shopify.currency.active,
    },
  ).format(cents / 100);
}

/**
 * @param {{freeDelivery:HTMLElement}} CartElement
 * @param {{totalPrice:number}} cart
 */
function customCheckFreeDelivery({ freeDelivery }, cart) {
  const { textPending, textSuccess, threshold } = freeDelivery.dataset;

  freeDelivery.style.display = Number(threshold) > 0 ? "" : "none";

  const elText = freeDelivery.querySelector(".js-free-delivery-text");
  if (!elText) return;

  elText.textContent =
    cart.totalPrice >= Number(threshold)
      ? textSuccess
      : textPending.replace(
          "[A]",
          customFormatMoney(Number(threshold) - cart.totalPrice),
        );
}

/**
 * @param {HTMLElement} elForm
 * @param {null | { id: number, title: string, option1: string, option2: string, option3: any, sku: string, requires_shipping: boolean, taxable: boolean, featured_image: any, available: boolean, name: string, public_title: string, options: string[], price: number, weight: number, compare_at_price: any, inventory_management: any, barcode: string, requires_selling_plan: boolean, selling_plan_allocations: any[], quantity_rule: unknown}} selectedVariant
 */
function customHandleVariantChange(elForm, selectedVariant) {
  if (!elForm || !selectedVariant) return;

  const elPriceRefs = elForm.querySelectorAll("product-price [data-ref=price]");
  const option1Label = elForm.querySelector("[data-ref=selectedOption1]");
  const option2Label = elForm.querySelector("[data-ref=selectedOption2]");
  const option1 = elForm.querySelector("[data-ref=option1]");
  const option2 = elForm.querySelector("[data-ref=option2]");

  if (option1 && option1Label) {
    option1Label.innerHTML = option1.selected;
  }
  if (option2 && option2Label) {
    option2Label.innerHTML = option2.selected;
  }

  if (!elPriceRefs.length) return;
  for (const elPrice of elPriceRefs) {
    elPrice.textContent = customFormatMoney(selectedVariant.price);
  }
}
